import { defineMessages } from 'react-intl';

export default defineMessages({
    copyrightMsg: {
        id: 'adac.footer.Copyright message',
        defaultMessage: '© 2022 ADAC'
    },
    privacyText: {
        id: 'adac.footer.Privacy',
        defaultMessage: 'Privacy'
    },
    privacyLink: {
        id: 'adac.footer.Privacy link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/ambulance-app/'
    },
    cookiesText: {
        id: 'adac.footer.Cookies',
        defaultMessage: 'Cookies'
    },
    cookiesLink: {
        id: 'adac.footer.Cookies link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/cookie-einstellungen/'
    },
    imprintText: {
        id: 'adac.footer.Imprint',
        defaultMessage: 'Imprint'
    },
    imprintLink: {
        id: 'adac.footer.Imprint link',
        defaultMessage: 'https://www.adac.de/produkte/versicherungen/impressum/allgemein/'
    },
    contactText: {
        id: 'adac.footer.Contact',
        defaultMessage: 'Contact'
    },
    contactLink: {
        id: 'adac.footer.Contact link',
        defaultMessage: 'https://www.adac.de/kontakt-zum-adac/'
    }
});
